import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap';
import SigniteButton from '../../ui-elements/signite-button/signiteButton';
import './login.css';
import img1 from '../../../imgs/login/1.png';
import { CandidateService, decodeJWT } from '../../../services/candidateService';
import { handleShowForgotPassword } from './password-management/forgotPassword';
import { useState, useEffect } from 'react';
import { ForgotPasswordDialog } from './password-management/forgotPassword';
import { VerifyOtpDialog } from './password-management/verifyOtp';
import { ResetPasswordDialog } from './password-management/resetPassword';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Nav } from 'react-bootstrap';
import logo from '../../../assets/images/Leaderly_TM.png';
import clientLoginImage from '../../../assets/images/client_login_image.png';
import RegisterFlow from '../../homepage/registerflow/registerflow';
import { FaRegSquare, FaCheckSquare, FaChevronDown } from 'react-icons/fa';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';

export const Login = () => {
  let [password, setPassword] = useState('');
  const [emailId, setEmailId] = useState('');
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');

  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showVerifyOtp, setShowVerifyOtp] = useState(false);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [errorMessage, setErrorMessage] = useState(sessionStorage.getItem('errorMessage') || '');
  const [successMessage, setSuccessMessage] = useState('');
  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const toggleShowLoginPassword = () => setShowLoginPassword(prev => !prev);

  const toggleShowNewPassword = () => setShowNewPassword(prev => !prev);
  const toggleShowConfirmPassword = () => setShowConfirmPassword(prev => !prev);

  const handlelogoclick = () => {
    window.location.href = '/';
  };

  useEffect(() => {
    if (errorMessage) {
      sessionStorage.setItem('errorMessage', errorMessage);
    } else {
      sessionStorage.removeItem('errorMessage');
    }
  }, [errorMessage]);
  const [isChecked, setIsChecked] = useState(false);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };

  const flowConfig = {
    verify: async (usernameOrEmail) => {
      try {
        await handleSendOtp(usernameOrEmail);
        setShowForgotPassword(false);
        setShowVerifyOtp(true);
      } catch (error) {
        console.error("OTP Error:", error);

        const backendMessage = error?.response?.data?.message;

        if (backendMessage === 'Deactivated User') {
          setErrorMessage('Your account has been deactivated. Please contact the administrator.');
        } else if (backendMessage) {
          setErrorMessage(backendMessage);
        } else {
          setErrorMessage('Invalid username or email. Please try again.');
        }
      }
    },
  };

  useEffect(() => {
    const savedUsername = localStorage.getItem('rememberedUsername');
    const savedPassword = localStorage.getItem('rememberedPassword');

    if (savedUsername && savedPassword) {
      setUsernameOrEmail(atob(savedUsername));
      setPassword(atob(savedPassword));
      setIsChecked(true);
    }
  }, []);

  const authenticate = () => {
    CandidateService.login(usernameOrEmail, password)
      .then((loginResponse) => {
        const { data } = loginResponse;
        const token = data.accessToken;
        const termsStatus = data.termsStatus;

        localStorage.setItem('authToken', token);
        if (termsStatus) {
          localStorage.setItem('termsStatus', termsStatus);
        } else {
          localStorage.removeItem('termsStatus');
        }
        localStorage.setItem('justLoggedIn', 'true');

        if (isChecked) {
          localStorage.setItem(
            'rememberedUsername',
            btoa(usernameOrEmail)
          );
          localStorage.setItem(
            'rememberedPassword',
            btoa(password)
          );
        } else {
          localStorage.removeItem('rememberedUsername');
          localStorage.removeItem('rememberedPassword');
        }

        //    const redirectPath =
        //   new URLSearchParams(window.location.search).get('redirect') || '/';

        // window.location.href = redirectPath;

        const redirectPath =
          new URLSearchParams(window.location.search).get('redirect');

        console.log("Redirect Path:", redirectPath);

        if (redirectPath) {
          window.location.href = redirectPath;
        } else {
          window.location.href = '/';
        }
      })

      .catch((err) => {
        console.error(err);

        if (err?.response?.data?.message === 'Deactivated User') {
          setErrorMessage(
            'Your account has been deactivated. Please contact the administrator.'
          );
        } else if (err?.response?.data?.message) {
          setErrorMessage(err.response.data.message);
        } else {
          setErrorMessage(
            'An error occurred while authenticating. Please check your username & password.'
          );
        }
      });

    return false;
  };

  const handleSendOtp = async (usernameOrEmail) => {
    try {
      await CandidateService.sendOtp(usernameOrEmail);
      return true;
    } catch (error) {
      if (error?.response?.data?.message === 'Deactivated User') {
        setErrorMessage('Your account has been deactivated. Please contact the administrator.');
      } else if (error?.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Failed to send OTP. Please check your email and try again.');
      }
      throw error;
    }
  };

  const handleVerifyOtp = (usernameOrEmail, otp) => {
    CandidateService.verifyOtp(usernameOrEmail, otp)
      .then(() => {
        setShowVerifyOtp(false);
        setShowPasswordReset(true);
      })
      .catch((error) => {
        console.error('API Error:', error.response?.data);
        setErrorMessage(error.response?.data?.message || 'Invalid OTP. Please try again.');
      });
  };
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;
    return passwordRegex.test(password);
  };
  const handleResetPassword = () => {
    if (!otp) {
      setErrorMessage("OTP is required to reset the password.");
      return;
    }
    if (!newPassword && !confirmPassword) {
      setErrorMessage("Please enter password to reset");
      return;
    }

    if (!newPassword || !confirmPassword) {
      setErrorMessage("Please enter all fields to reset password");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match. Please try again.");
      return;
    }
    if (!validatePassword(newPassword)) {
      setErrorMessage("Password must be at least 8 characters long and include an uppercase letter, a number, and a special character.");
      return;
    }
    CandidateService.resetPassword(usernameOrEmail, otp, newPassword, confirmPassword)
      .then(() => {
        setShowPasswordReset(false);
        setSuccessMessage("Password reset successful! Please log in.");

        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      })
      .catch((error) => {
        console.error("Password reset failed:", error.response?.data);
        setErrorMessage(error.response?.data?.message || "Failed to reset password. Please try again.");
      });
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      authenticate();
    }
  };
  const handleNavigation = (path, section) => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = `${path}?section=${section}`;
  };

  const helpNavigation = () => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = '/navbar-faq';
  };

  const handleRegisterClick = () => {
    setRegisterPopupVisible(true);
    // handleSidebarClose();
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };
  return (
    // <Container fluid >
    <div className='fluid-container'>
      {/* Navbar */}
      <nav className="navbar navbar-light bg-white px-5 " style={{ position: 'fixed', top: '0', left: '0', width: '100%', zIndex: '1000', backgroundColor: 'white' }}>
        <a className="navbar-brand " href="#">
          <img src={logo} alt="Logo" onClick={handlelogoclick} />
        </a>
        <div className="ms-auto">
          {/* Large Screen Links */}
          <div className="client-loginnav-links d-none d-md-flex">
            <a className='client-loginnav-links-a' onClick={() => handleNavigation("/policy", "privacy")}>Privacy Policy</a>
            <span>|</span>
            <a className='client-loginnav-links-a' onClick={() => helpNavigation()}>Help</a>
            <span>|</span>
            <a className='client-loginnav-links-a' onClick={() => handleNavigation("/policy", "terms")}>Terms & Conditions</a>
          </div>

          {/* Small Screen Dropdown */}
          <div className="d-md-none">
            <a className='client-loginnav-links-a' href="/feedback" onClick={(e) => handleNavigation("/feedback", e)}>Help</a>
            <span>|</span>
            <button className="clientlogin-dropdown-toggle-btn" onClick={() => setShowDropdown(!showDropdown)}>
              Policy <FaChevronDown className={`clientlogin-dropdown-icon ${showDropdown ? 'rotate' : ''}`} />
            </button>
            {showDropdown && (
              <div className="clientlogin-dropdown-menu">
                <a className='client-loginnav-links-a' onClick={() => handleNavigation("/policy", "privacy")}>Privacy Policy</a>
                <a className='client-loginnav-links-a' onClick={() => handleNavigation("/policy", "terms")}>Terms & Conditions</a>
              </div>
            )}
          </div>
        </div>
      </nav>
      {errorMessage && (
        <div className="login-alert-overlay">
          <div className="login-alert-box">
            <div className="login-alert-content">
              <p>{errorMessage}</p>
              <button className="login-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {successMessage && (
        <div className="login-alert-overlay">
          <div className="login-alert-box">
            <div className="login-alert-content">
              <p>{successMessage}</p>
              <button className="login-alert-button" onClick={() => {
                setSuccessMessage('');
                window.location.href = '/login';
              }}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <ForgotPasswordDialog
        show={showForgotPassword}
        setShow={setShowForgotPassword}
        flowConfig={flowConfig}
        usernameOrEmail={usernameOrEmail}
        setUsernameOrEmail={setUsernameOrEmail}
      />
      <VerifyOtpDialog
        show={showVerifyOtp}
        setShow={setShowVerifyOtp}
        flowConfig={{ verify: () => handleVerifyOtp(usernameOrEmail, otp) }}
        otp={otp}
        setOtp={setOtp}
        usernameOrEmail={usernameOrEmail}
      />
      <ResetPasswordDialog
        show={showPasswordReset}
        setShow={setShowPasswordReset}
        flowConfig={{ verify: handleResetPassword }}
        usernameOrEmail={usernameOrEmail}
        otp={otp}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        showNewPassword={showNewPassword}
        showConfirmPassword={showConfirmPassword}
        toggleShowNewPassword={toggleShowNewPassword}
        toggleShowConfirmPassword={toggleShowConfirmPassword}
      />
      <div className="app-container">
        <div className="main-content">
          <Row className="align-items-center justify-content-center m-0 p-0 w-100">

            <Col
              className="d-flex align-items-center justify-content-center position-relative form-container"
              sm={7}
              md={8}
              lg={7}
            >
              <button className="client-login-back-button" onClick={() => window.history.back()}>
                <img src={profilebackButtonIcon} />
                {' '}Back
              </button>
              <Form className="login-form" >
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <h4 className='login-title'> Login </h4>
                  <Form.Control
                    type="text"
                    placeholder="Username or Email"
                    value={usernameOrEmail}
                    onChange={(evt) => setUsernameOrEmail(evt.target.value)}
                    className='client-login-form-input'
                    spellCheck="false"
                    autoComplete='new-email'
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="mb-3 position-relative">
                  <Form.Control
                    type={showLoginPassword ? 'text' : 'password'}
                    placeholder="Password"
                    value={password}
                    onChange={(evt) => setPassword(evt.target.value)}
                    onKeyDown={handleKeyDown}
                    className='client-login-form-input'
                    spellCheck="false"
                    autoComplete='new-password'
                  />
                  <span
                    onClick={toggleShowLoginPassword}
                    style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#6c757d'
                    }}
                  >
                    <FontAwesomeIcon icon={showLoginPassword ? faEyeSlash : faEye} />
                  </span>
                </Form.Group>


                <Form.Group controlId="formBasicPassword" className="mb-3 d-flex justify-content-between">
                  <a href="#" className="forgotPassword" onClick={() => setShowForgotPassword(true)}>
                    Forgot Password?
                  </a>
                  <div className="d-flex align-items-center" onClick={toggleCheckbox} style={{ cursor: "pointer" }}>
                    {isChecked ? (
                      <FaCheckSquare className="remember-check-icon" />
                    ) : (
                      <FaRegSquare className="remember-icon" />
                    )}
                    <label className="ms-2 rememberMe">Remember Me</label>
                  </div>
                </Form.Group>

                <div className="d-flex justify-content-center">
                  <SigniteButton variant="primary" className={'loginBtn'} onClick={() => authenticate()}>
                    Login{' '}
                  </SigniteButton>
                </div>

                <div className="d-flex justify-content-center new-user">
                  <p>New User ? <span onClick={handleRegisterClick}>Register</span></p>
                </div>
              </Form>
            </Col>

            <Col className="d-none d-lg-flex flex-column postloginImageContainer m-0 p-0">
              <div style={{ padding: "30px", width: "100%" }}>
                <h2 className="login-image-head">Find the Great Minds of India</h2>
              </div>
              <Image src={clientLoginImage} className="login-image" />
            </Col>


          </Row>
        </div>

        <footer className="text-center py-3 border-top bg-white client-login-footer">
          <small>© 2026 Signite Technology Pvt Ltd. All rights reserved.</small>
        </footer>
        <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
      </div>

    </div>);
};